import React, { useState, useEffect } from 'react';
import ProduccionRetiroEditor from './ProduccionRetiroEditor';
import { connect } from 'react-redux';
import {
  getAllByParent,
  setPending,
  deleted,
} from '../redux/actions/produccionRetiroActions';
import { callStatus } from '../utils/constants';
import { Button, Space, Layout, Modal } from 'antd';
import { withRouter } from 'react-router-dom';
import {
  EditFilled,
  DeleteFilled,
  PlusCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';
import MetaTable from './base/MetaTable';
import dayjs from 'dayjs';
import { convertDate } from '../utils/funtions';
import CustomCellRender from './base/CustomCellRender';
const { confirm } = Modal;

const { Content, Header, Footer } = Layout;

const SelectedContainer = styled.div`
  flex: 1;
`;

const ActionsContainer = styled.div``;

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 10px;
`;
const ProduccionRetiroList = ({
  location,
  stateData,
  dispatch,
  match: {
    params: { id, id2 },
  },
  parent,
}) => {
  const [showEdit, setShowEdit] = useState(false);

  const [rowEdit, setRowEdit] = useState(null);
  useEffect(() => {
    dispatch(getAllByParent(id2));
    // eslint-disable-next-line
  }, []);

  const handleEdit = (data) => {
    setRowEdit(data);
    setShowEdit(true);
  };

  const handleDelete = (data) => {
    dispatch(deleted(data.id));
  };

  const handleHideEditor = () => {
    setShowEdit(false);
    setRowEdit(null);
    dispatch(setPending());
  };

  const handleConfirm = (item) => {
    confirm({
      title: 'Esta a punto de eliminar un registro, desea continuar?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Si',
      cancelText: 'No',
      autoFocusButton: 'cancel',
      onOk() {
        handleDelete(item);
      },
      onCancel() {},
    });
  };

  const columns = [
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <EditFilled onClick={(e) => handleEdit(record)} />
          <DeleteFilled onClick={(e) => handleConfirm(record)} />
        </Space>
      ),
      width: 90,
    },
    {
      width: 100,
      ellipsis: true,
      title: 'Fecha',
      dataIndex: 'fecha',
      render: (text) =>
        text ? dayjs(convertDate(text)).format('DD/MM/YYYY') : '',
    },

    {
      width: 120,
      ellipsis: true,
      title: 'Cantidad Tn',
      dataIndex: 'cantidad',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 120,
      ellipsis: true,
      title: 'Precio Cantidad $',
      dataIndex: 'precio_unitario',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 120,
      ellipsis: true,
      title: 'Dolar',
      dataIndex: 'dolar',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      width: 120,
      ellipsis: true,
      title: 'Importe U$D',
      dataIndex: 'importe',
      render: (text) => (
        <CustomCellRender text={text} justify={'space-between'} prefix={''} />
      ),
    },
    {
      ellipsis: true,
      title: 'Camionero',
      dataIndex: 'camionero',
    },
    {
      ellipsis: true,
      title: 'Destino',
      dataIndex: 'destino',
      render: (text, record) => record.destino?.nombre,
    },

    {
      ellipsis: true,
      title: 'Aportante',
      dataIndex: 'inversor',
      render: (text, record) => record.inversor?.nombre,
    },
  ];
  return (
    <Layout style={{ height: '100%' }}>
      <Header></Header>
      <Content>
        <MetaTable
          dataSource={stateData.list.data}
          dataColumns={columns}
          bordered={false}
          selection={false}
          loading={stateData.list.status === callStatus.LIST_IN_PROCESS}
        />
      </Content>
      <Footer>
        <FooterContainer>
          <SelectedContainer></SelectedContainer>
          <ActionsContainer>
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              size="small"
              onClick={(e) => handleEdit({})}
            >
              Agregar
            </Button>
          </ActionsContainer>
        </FooterContainer>
      </Footer>
      {showEdit ? (
        <ProduccionRetiroEditor
          id={rowEdit.id}
          parentId={id2}
          onCancel={handleHideEditor}
          visible={true}
        />
      ) : (
        false
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => {
  const { produccionRetiro, actividad } = state;
  const stateData = produccionRetiro;
  const parent = actividad;

  return {
    stateData,
    parent,
  };
};
export default connect(mapStateToProps)(withRouter(ProduccionRetiroList));
